export const COW_STATUS_TRANSLATIONS = {
  title: "Înțelegerea Statusului Bovinei Tale",

  howStatusUpdatesWork: {
    title: "Cum Funcționează?",
    description:
      "Urmărim automat statusul bovinei tale pe baza a ceea ce înregistrezi. Fiecare status se actualizează ori de câte ori înregistrezi un eveniment relevant.",
  },

  statusTypes: {
    title: "Tipuri de Status",

    healthy: {
      title: "Sănătoasă",
      meaning: "Arată dacă bovina ta este în stare bună de sănătate acum.",
      becomesTrue: "Când înregistrezi un control de sănătate pozitiv",
      becomesFalse:
        "Când înregistrezi un control de sănătate negativ, tratament pentru boală, tratament pentru rănire, operație, control post-operator sau vaccinare",
    },

    underTreatment: {
      title: "Sub Tratament",
      meaning:
        "Arată dacă bovina ta primește în prezent îngrijiri medicale sau medicamente.",
      becomesTrue:
        "Când înregistrezi orice îngrijire medicală precum vaccinări, tratamente pentru boli, deparazitare, tratamente pentru răni, operații, controale post-operatorii sau administrarea de suplimente",
      becomesFalse: "Când înregistrezi un control de sănătate pozitiv",
    },

    pregnant: {
      title: "Gestantă",
      meaning: "Arată dacă bovina ta așteaptă un vițel.",
      becomesTrue: "Când înregistrezi un control de gestație pozitiv",
      becomesFalse:
        "Când înregistrezi un control de gestație negativ, avort, naștere, inseminare, împerechere naturală sau detectarea căldurii",
    },

    inHeat: {
      title: "În Călduri",
      meaning:
        "Arată dacă bovina ta este în ciclul reproductiv și gata să se împerecheze.",
      becomesTrue: "Când înregistrezi detectarea căldurii",
      becomesFalse:
        "Când înregistrezi un control de gestație pozitiv, inseminare sau împerechere naturală",
    },

    lactating: {
      title: "Lactație",
      meaning: "Arată dacă bovina ta dă lapte în prezent.",
      becomesTrue: "Când înregistrezi începutul lactației",
      becomesFalse: "Când înregistrezi sfârșitul lactației sau întăritul",
    },
  },

  labels: {
    whatItMeans: "Ce înseamnă?",
    whenItBecomesTrue: "Când se activează?",
    whenItBecomesFalse: "Când se dezactivează?",
  },
}
